<template>
  <div class="bg-222021">
    <div
      class="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-8 lg:px-12 lg:flex lg:items-center md:text-left text-center"
    >
      <div class="lg:w-0 lg:flex-1">
        <h6
          class="md:text-3xl text-xl font-semibold leading-normal mt-0 mb-4 text-white"
        >
          Get a free class when you sign up for our newsletter.
        </h6>
      </div>
      <div class="mt-8 lg:mt-0 lg:ml-8">
        <form
          ref="anyName"
          class="sm:flex items-center"
          @submit.prevent="submitHandler"
        >
          <div class="flex flex-col">
            <label class="text-gray-lighter text-xs -mt-4">Email*</label>
            <input
              type="email"
              autocomplete="email"
              class="w-full px-5 py-2 ring-1 placeholder-gray-500 focus:ring-1 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white focus:border-white sm:max-w-xs rounded-md bg-gray-dark bg-222021 text-white"
              placeholder="mail@website.com"
              v-model="$v.email.$model"
              :class="{ 'ring-red-700': $v.email.$error }"
            />
            <div v-if="$v.email.$error">
              <span class="text-red-700" v-if="!$v.email.required">
                Email field is required.
              </span>
              <span class="text-red-700" v-if="!$v.email.email">
                Accepts valid email addresses.
              </span>
            </div>
          </div>
          <div
            class="mt-6 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0 flex justify-center"
          >
            <button
              type="submit"
              class="md:w-48 flex items-center justify-center px-5 py-2 ring-1 ring-green-light border-transparent text-md font-medium rounded-md text-white bg-green-light hover:bg-green-light focus:outline-none"
            >
              Join Now
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "Newsletter",
  props: {
    categories: {
      type: Array,
    },
  },
  data() {
    return {
      email: null,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    ...mapActions(["postSubscribe"]),

    submitHandler() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        const data = {
          email: this.email,
        };
        this.postSubscribe(data)
          .then(() => {
            this.$refs.anyName.reset();
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.bg-222021 {
  background-color: #222021;
}
</style>